import styled, { css } from 'styled-components'

import { Cover, Reset, TransitionPrimary } from '@/lib/mixins'

export const MenuCategoryBorder = styled.div`
  ${Cover()}
  border: 2px solid ${props => props.theme.color.primary};
  opacity: 0;
  ${TransitionPrimary('opacity')};
`

export const MenuCategoryLabel = styled.div`
  font-family: ${props => props.theme.font.secondary};
  font-size: 19px;
  margin-top: 15px;
  text-align: center;
`

export const MenuCategoryWrapper = styled.button`
  ${Reset('button')}
  display: flex;
  flex-direction: column;
  position: relative;
  height: 160px;
  flex-shrink: 0;
  align-items: center;
  margin: 5px 0;
  justify-content: center;
  opacity: ${props => (props.active || props.isPressed ? 1 : 0.5)};
  ${TransitionPrimary('opacity')}

  svg {
    fill: currentColor;
    width: 50px;
    height: 50px;
  }

  ${props =>
    props.active &&
    css`
      ${MenuCategoryBorder} {
        opacity: 1;
      }
    `};
`
